import { PostHog } from 'posthog-js';

export function setFeatureFlags(posthog: PostHog, featureFlags: Record<string, string | boolean>) {
  posthog.featureFlags.override(featureFlags);
}
